import {
  CLICKED_REGIONSELECT_TOPNAV,
  CLICKED_SIGNIN_TOPNAV,
  CLICKED_SIGNOUT_TOPNAV,
  CLICKEDAWAY_REGIONSELECT_TOPNAV,
  CLOSED_REGIONSELECT_TOPNAV,
  OPENED_HOME,
  REACHED_REDIRECT_LIMIT,
} from "./../../common/analytics/analyticsevents";
import DownloadComponent from "./../../common/components/downloadcomponent";
import language from "./../../common/dictionary";
import ContentPackageStore from "./../../common/stores/contentPackageStore";
import NewsstandRedirectingStore from "./../../common/stores/newsstandRedirectingStore";
import PromospotStore from "./../../common/stores/promospotStore";
import APIManager from "./../../common/utilities/apimanager";
import CookieManager from "./../../common/utilities/cookiemanager";
import { PAYWALL_REDIRECTION } from "./../../common/utilities/redirectorKeys";
import {
  createDivWithClass,
  getFullPaywallRedirectionUrl,
  getParameterByName,
  goToPublication,
  noop,
  removeURLParameter,
} from "./../../common/utilities/utils";
import App from "./../shared/app";
import HelpButtonComponent from "./../shared/components/helpButtonComponent";
import SettingsButtonComponent from "./../shared/components/settingsButtonComponent";
import TopBarComponent from "./../shared/components/topBarComponent";
import Kiosque from "./components/kiosque";
import TopNavButtonComponent from "./components/topNavButtonComponent";
import appHome from "./templates/appHome.dust";
import topBarCenter from "./templates/topBarCenter.dust";
import { hideLoaderAndChangeLocation } from "../../common/utilities/location";

export default class AppHome extends App {
  constructor() {
    super();
    this.init();
  }

  initRender() {
    this.render(appHome);
  }

  createContext() {
    const context = {};
    if (
      this.options.authenticatorauthorisationcontroller.subscriptionOptions
        .subscriptionType !== "free"
    ) {
      context.access = language.SignIn;
    }
    return context;
  }

  initAfterRendering() {
    this.topBar = new TopBarComponent();
    this.topBar.render(
      this.options.logoRedirect,
      this.options.useCustomTooltips
    );
    this.topBar.on("topBar:logoClicked", () => {
      if (this.options.logoRedirect) {
        hideLoaderAndChangeLocation(this.options.logoRedirect, window);
      }
    });
    this.topBar.on("topBar:rendered", () => {
      const access = this.DOMContainer.querySelector(".top-bar-access");
      if (access) {
        this.renderLoginLink(access);
        this.renderTopNavButton(access);
        this.renderSettingsOption();
        this.renderHelpOption();
      }
      const container = this.DOMContainer.querySelector(".top-bar-center");
      if (container) {
        Dust.render(topBarCenter, {}, (err, result) => {
          container.innerHTML = result;
          //retreive region
          this.regionManager
            .getRegion(this.DOMContainer.querySelector("#regionSelector"))
            .then((region) => {
              if (!this.regionManager.singleRegion) {
                const arrow = container.querySelector(".top-bar-arrow");
                if (arrow) {
                  arrow.classList.remove("hidden");
                  arrow.addEventListener("click", () => {
                    this.regionClicked();
                  });
                }
                const region = this.DOMContainer.querySelector(
                  ".top-bar-container .top-bar-center .current-region .top-bar-region"
                );
                if (region) {
                  region.classList.add("pointer");
                  region.addEventListener("click", () => {
                    this.regionClicked();
                  });
                }
              }
              let downloadToken = getParameterByName("downloadToken");
              if (downloadToken) {
                hideLoaderAndChangeLocation(
                  removeURLParameter("downloadToken"),
                  window
                );
              }
              this.authenticatorAuthorisationController
                .authenticate()
                .then(() => {})
                .catch(() => {})
                .then(() => {
                  //PAR-PAR needs the region name sent when the OPENED_HOME event is fired
                  this._appState.triggerEvent(
                    OPENED_HOME,
                    { region: region.Description },
                    true
                  );
                });
              // this.authenticatorAuthorisationController.authenticate();  //TODO: uncaught in promise
            });
        });
      }
    });
    this.kiosque = new Kiosque(
      this._appState,
      this.DOMContainer.querySelector("#app-content"),
      this.options.kiosque
    );
  }

  onPublicationClicked(publicationData) {
    publicationData.price = this.contentPackageStore.getContentPackagePrice(
      publicationData.contentPackageId
    );
    if (publicationData.price === undefined) {
      publicationData.price = this.horsSeriesStore.getContentPackagePrice(
        publicationData.contentPackageId
      );
    }
    this.loader.show();
    const downloadComponent = new DownloadComponent(
      this.authenticatorAuthorisationController,
      this.paywall,
      this.options.downloadComponent,
      APIManager,
      this._appState,
      this.errorPopup
    );
    downloadComponent.on("downloadComponent:succes", (data) => {
      this.goToPublication(data);
    });
    downloadComponent.on("downloadComponent:close", () => {
      this.loader.hide();
    });
    downloadComponent.validateDownload(publicationData, true);
  }

  goToPublication(publicationData) {
    this.loader.hide();
    goToPublication(publicationData, this.options.kiosque.homeRelativeDepth);
  }

  closeRegionSelector = (e) => {
    const topNavRegionSelector = this.DOMContainer.querySelector(
      "#region-list-container"
    );
    const region = this.DOMContainer.querySelector(".current-region");

    if (
      topNavRegionSelector !== e.target &&
      !topNavRegionSelector.contains(e.target) &&
      !region.contains(e.target)
    ) {
      if (!topNavRegionSelector.classList.contains("hidden")) {
        this._appState.triggerEvent(CLICKEDAWAY_REGIONSELECT_TOPNAV);
        topNavRegionSelector.classList.add("hidden");
        document.removeEventListener("click", this.closeRegionSelector);
      }
    }
  };

  regionClicked() {
    const element = this.DOMContainer.querySelector("#region-list-container");
    if (element) {
      if (element.classList.contains("hidden")) {
        this.regionManager.getRegion(element, true, true).then(() => {});
        document.addEventListener("click", this.closeRegionSelector);
        this._appState.triggerEvent(CLICKED_REGIONSELECT_TOPNAV);
      } else {
        element.classList.add("hidden");
        this._appState.triggerEvent(CLOSED_REGIONSELECT_TOPNAV);
      }
    }
  }

  accessClicked() {
    if (this._appState.isLoggedIn) {
      this.authenticatorAuthorisationController.logOut();
      this._appState.triggerEvent(CLICKED_SIGNOUT_TOPNAV);
    } else {
      if (this.options.downloadComponent.paywallRedirectionUrl) {
        const number = CookieManager.getNumberOfRedirects();
        if (
          number >=
          this.options.downloadComponent.externalPaywallMaxRedirectionNumber
        ) {
          this._appState.triggerEvent(REACHED_REDIRECT_LIMIT);
          this.paywall.show();
        } else {
          APIManager.getUserProfileValue(PAYWALL_REDIRECTION)
            .then((result) => {
              if (
                result &&
                result[0] &&
                result[0].Value &&
                result[0].Value.length > 0
              ) {
                CookieManager.setNumberOfRedirects(
                  number + 1,
                  this.options.downloadComponent.paywallRedirectionTimeReset
                );

                hideLoaderAndChangeLocation(
                  getFullPaywallRedirectionUrl(
                    result[0].Value,
                    this.authenticatorAuthorisationController,
                    this.options.authenticatorauthorisationcontroller
                  ),
                  window
                );
              } else {
                this.paywall.show();
              }
            })
            .catch(() => {
              this.paywall.show();
            });
        }
      } else {
        this.paywall.show();
      }
      this._appState.triggerEvent(CLICKED_SIGNIN_TOPNAV);
    }
  }

  attachListeners() {
    this._appState.on("appState:authenticationstatuschanged", () => {
      this.onAuthenticationStatusChanged();
    });
    this._appState.on("appState:downloadtokenchanged", () => {
      this.onDownloadTokenChanged();
    });
    this.kiosque.on("kiosque:onPublicationClicked", (publicationData) => {
      this.onPublicationClicked(publicationData);
    });
  }

  onDownloadTokenChanged() {
    const region = this.DOMContainer.querySelector(
      ".top-bar-container .top-bar-center .top-bar-region"
    );
    if (region) {
      if (
        this.options.kiosque &&
        this.options.kiosque.customKiosqueTitle.length > 0
      ) {
        region.innerHTML = this.options.kiosque.customKiosqueTitle;
      } else {
        region.innerHTML = this.regionManager.getCurrentRegion().Description;
      }
    }
    this.initStores();
  }

  onAuthenticationStatusChanged() {
    let login = "";
    const divLogin = this.DOMContainer.querySelector(
      ".top-bar-container .top-bar-access .access-login"
    );
    if (this._appState.isLoggedIn) {
      login = language.SignOut;
      divLogin.classList.add("signOut");
      if (
        this.options.kiosque &&
        this.options.kiosque.toggleSubscriptionTopNavButtonOnUserLoggedIn &&
        divLogin
      ) {
        divLogin.classList.add("hidden");
      }
    } else {
      login = language.SignIn;
      divLogin.classList.remove("signOut");
      if (
        this.options.kiosque &&
        this.options.kiosque.toggleSubscriptionTopNavButtonOnUserLoggedIn &&
        divLogin
      ) {
        divLogin.classList.remove("hidden");
      }
    }

    if (divLogin) {
      divLogin.innerHTML = login;
    }
  }

  initStores() {
    APIManager.getAdditionalDownloadTokens()
      .then((json) => {
        //for sidemenu
        this.initHorsseriesStore(json);
      })
      .catch(noop);
    this.initContentPackageStore();
    this.initPromospotStore();
    this.initNewsstandRedirectingStore();
  }

  initContentPackageStore() {
    this.contentPackageStore = new ContentPackageStore(
      APIManager,
      this._appState,
      language.moment,
      this.options.sizes.covers,
      this.options.dateFormat,
      this.options.contentPackageStore
    );
    this.contentPackageStore.on("contentPackages:loaded", () => {
      this.onContentPackagesLoaded();
    });
    this.contentPackageStore.loadContentPackages(
      this._appState.downloadToken,
      Math.max(
        this.options.kiosque.archiveLength,
        this.options.sidemenu.recentlyLength
      )
    );
  }

  initPromospotStore() {
    if (this.options.kiosque.usePromoSpot) {
      this.promospotStore = new PromospotStore(
        APIManager,
        this.options.sizes.covers,
        this.options.promospot
      );
      this.promospotStore.on("promospot:loaded", () => {
        this.onPromospotLoaded();
      });
      this.promospotStore.loadPromospot(this._appState.downloadToken);
    }
  }

  initNewsstandRedirectingStore() {
    if (
      this.options.newsstandRedirecting &&
      this.options.newsstandRedirecting.length
    ) {
      this.newsstandRedirectingStore = new NewsstandRedirectingStore(
        APIManager,
        this._appState,
        this.options.newsstandRedirecting,
        this.options.sizes.covers,
        this._appState.downloadToken
      );
      this.newsstandRedirectingStore.on("NewsstandRedirecting:loaded", () => {
        this.onNewsstandRedirectingLoaded();
      });
      this.newsstandRedirectingStore.loadNewsstandRedirecting();
    }
  }

  onNewsstandRedirectingLoaded() {
    const packages = this.newsstandRedirectingStore.getAllContentPackages();
    this.kiosque.setNewsstandRedirecting(packages);
  }

  onContentPackagesLoaded() {
    const packages = this.contentPackageStore.getAllContentPackages();
    this.kiosque.setContentPackages(packages);
  }

  onPromospotLoaded() {
    this.kiosque.setPromospot(this.promospotStore.getPromospotList());
  }

  onHorsseriesLoaded() {
    if (this.options.kiosque.displayHorsSerieArchive) {
      const packages = this.horsSeriesStore.getHorsseries();
      this.kiosque.setHorsseries(packages);
    }
  }

  startApp() {
    //this._appState.triggerEvent(OPENED_HOME);
  }

  renderTopNavButton(container) {
    if (this.options.kiosque.topNavBtnCookieConsent) {
      new TopNavButtonComponent(
        this._appState,
        container,
        this.options.kiosque,
        true
      );
    } else {
      new TopNavButtonComponent(
        this._appState,
        container,
        this.options.kiosque
      );
    }
  }

  renderLoginLink(container) {
    const {
      settings: {
        subscriptionOptions: { subscriptionType },
      },
    } = this.options;
    if (!container || subscriptionType === "free") return;
    const accessLogin = createDivWithClass("access-login");

    if (this._appState.isLoggedIn) {
      accessLogin.classList.add("signOut");
      if (
        this.options.kiosque &&
        this.options.kiosque.toggleSubscriptionTopNavButtonOnUserLoggedIn
      ) {
        accessLogin.classList.add("hidden");
      }
    } else {
      accessLogin.classList.remove("signOut");
    }

    accessLogin.innerHTML = language.SignIn;
    accessLogin.classList.add("pointer");
    container.appendChild(accessLogin);
    accessLogin.addEventListener("click", () => {
      this.accessClicked();
    });
  }

  renderSettingsOption() {
    if (this.options.settings.turnOnSettings) {
      const settingsButtonComponent = new SettingsButtonComponent(
        this._appState,
        this.regionManager,
        this.sessionManager,
        this.paywall,
        this.options.settings
      );
      settingsButtonComponent.render();
    }
  }

  renderHelpOption() {
    if (this.options.help && this.options.help.turnOnHeaderHelp) {
      const helpButtonComponent = new HelpButtonComponent(
        this._appState,
        this.regionManager,
        this.sessionManager,
        this.paywall,
        this.options.settings
      );
      helpButtonComponent.render();
    }
  }
}



// WEBPACK FOOTER //
// ./src/web/home/appHome.js